import { SlotGame } from "@nolimitcity/slot-game/bin/SlotGame";
import { SoundConfig } from "./SoundConfig";
import { INolimitAudioPlayer } from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";
import { NolimitHowl } from "@nolimitcity/slot-audio/bin/NolimitHowl";
import { ArrayHelper } from '../../../dev/utils/ArrayHelper';
import { MathHelper } from '../../../dev/utils/MathHelper';
import { Helper } from '../../../dev/utils/Helper';
import { gsap } from "gsap";


export class SoundManager {

    protected static currentLoop: string[] = [""];
    private static currentBigWin: string = "";

    private static standardVolume = 1;
    private static deadVolume = 0.35;

    private static fsIntroClicked: boolean = false;

    private static feelVolume = 0.5;
    private static feelLevel = 0;

    private static tlCounter: gsap.core.Timeline;


    private static getFeelVolume(lvl:number):number{
        return 0.5 + lvl*0.1;
    }

    public static get soundPlayer(): INolimitAudioPlayer {
        return <INolimitAudioPlayer>SlotGame.sound;
    }

    private static PanningForStop: number[] = [0, 0, 0, 0, 0];

    public static playReelStop(reelID: number, aniticipation:boolean = false): void {
        const soundName: string = aniticipation ? SoundConfig.SCATTER_ANTICIPATION_LANDING : SoundConfig.REELS_LANDING;// + (reelID + 1);
        const sound: NolimitHowl | undefined = this.soundPlayer.fetchSoundPlayer(soundName)
        if (sound) sound.player.stereo(this.PanningForStop[reelID]);
        this.soundPlayer.stopTrack(soundName);
        this.soundPlayer.playTrack({ name: soundName });
    }

    public static setDeadSpinVolume(val: boolean) {
        this.standardVolume = val ? this.deadVolume : 1;
    }

    public static playScatterLand(lvl:number,dead:boolean): NolimitHowl | undefined {
        SoundConfig.SCATTER_LANDINGS.forEach((soundName:string) =>  this.soundPlayer.stopTrack(soundName));
        return this.soundPlayer.playTrack({name: SoundConfig.SCATTER_LANDINGS[lvl], volume:dead ? this.deadVolume : 1});
    }

    private static takeOffSound:string = "wcTakeOff3";
    public static playTakeOffSound(): NolimitHowl | undefined {
        this.takeOffSound = ArrayHelper.fetchNextInList(this.takeOffSound,SoundConfig.CAR_TAKE_OFF)
        return this.soundPlayer.playTrack({
            name: this.takeOffSound,
            volume: this.standardVolume 
        });
    }

    public static stopTakeOffSound(): NolimitHowl | undefined {
        return this.soundPlayer.stopTrack(this.takeOffSound);
    }
    
    public static playSoundEffect(name: string, repeat?: number, volume?: number): NolimitHowl | undefined {
        if(name === SoundConfig.MULT_LAND || name === SoundConfig.MULT_LAND_UPGRADE)
            this.soundPlayer.stopTrack(name)

        return this.soundPlayer.playTrack({
            name: name,
            repeat: repeat,
            volume: this.standardVolume 
        });
    }

    private static respinType:number = 0;
    public static playRespinSound(): NolimitHowl | undefined {
        const respinLoop:string = !this.respinType ? SoundConfig.RESPIN_ANTICIPATION : SoundConfig.RESPIN_ANTICIPATION_2;
        this.respinType = (this.respinType+1)%2;
        return this.soundPlayer.playTrack({
            name: respinLoop,
            repeat: 5,
            volume: 1
        });
    }

    public static stopRespinSound(): NolimitHowl | undefined {
        const respinLoop:string = this.respinType ? SoundConfig.RESPIN_ANTICIPATION : SoundConfig.RESPIN_ANTICIPATION_2;
        const endSound:string = this.respinType ? SoundConfig.RESPIN_ANTICIPATION_END : SoundConfig.RESPIN_ANTICIPATION_END_2;
        this.stopSoundEffect(respinLoop);

        return this.soundPlayer.playTrack({
            name: endSound,
            volume: 1
        });
    }

    public static startAmbient(): void {
        this.currentLoop.forEach(loop => {
            this.soundPlayer.playTrack({name:loop,volume:1, repeat:Number.MAX_SAFE_INTEGER});
        });
    }

    public static stopAmbient(): void {
        this.currentLoop.forEach(loop => {
            this.soundPlayer.stopTrack(loop);
        });
    }

    public static fadeOutAmbient(duration: number = 2000, volume: number = 0): void {
        this.currentLoop.forEach(loop => {
            this.soundPlayer.fadeTrack({ name: loop, duration: duration, to:  volume });
        });
    }

    public static fadeInAmbient(duration: number = 3000, volume: number = 1): void {
        this.currentLoop.forEach(loop => {
            this.soundPlayer.fadeTrack({ name: loop, duration: duration, to: loop === SoundConfig.MAIN_MUSIC ? this.getFeelVolume(this.feelLevel) : volume });
        });
    }

    public static startNewFsMusic(intro:string, loop:string): void {
        this.ChangeToLoop([loop]);

        const p = this.soundPlayer.playTrack({ name: intro })

        if (!p) {
            this.soundPlayer.stopTrack(intro);
            this.startAmbient();
        } else {
            p.player.loop(false);
            p.player.once("end", () => {
                this.startAmbient();
            } )
        }
    }

    public static playBigWin(lvl: number, skipped: boolean = false, repeats: boolean): void {
        
        const nextBigWinSound: string = SoundConfig.bigWinLoop(lvl);

        this.soundPlayer.stopTrack(this.currentBigWin);
        this.soundPlayer.stopTrack(SoundConfig.BIG_WIN_LVL_CHANGE)
       
        if(this.currentBigWin != nextBigWinSound && lvl != 1)
            this.playSoundEffect(SoundConfig.BIG_WIN_LVL_CHANGE)
            
        this.soundPlayer.playTrack({ name: nextBigWinSound, repeat: repeats ? Number.MAX_SAFE_INTEGER : 0 });

        this.currentBigWin = nextBigWinSound;
    }

    public static fadeBigWin(durr:number): void {
        this.feelLevel = 4;
        this.soundPlayer.fadeTrack({ name: this.currentBigWin, from: 1, to: 0, duration: durr });
    }

    public static stopBigWin(): void {
        this.soundPlayer.stopTrack(this.currentBigWin);
        this.currentBigWin = "";
    }

    public static onBet(lvl?:number): void {
        this.tlCounter = Helper.setTimeline(this.tlCounter, new gsap.core.Timeline());
    
        this.soundPlayer.playTrack({ name: SoundConfig.MAIN_MUSIC, volume:this.getFeelVolume(this.feelLevel) });

        if(lvl != undefined && lvl){
            this.feelLevel = MathHelper.clamp(this.feelLevel + lvl, 0 , 4);
            this.soundPlayer.fadeTrack({name:SoundConfig.MAIN_MUSIC, to: this.getFeelVolume(this.feelLevel), duration:1e4 });
        }

        this.ApplyLoop(SoundConfig.MAIN_MUSIC);
    }

    public static onIdle(): void {
        this.tlCounter = Helper.setTimeline(this.tlCounter, new gsap.core.Timeline());
        if(this.soundPlayer.allPlayers()[0] && this.currentLoop.includes(SoundConfig.MAIN_MUSIC)){
            this.tlCounter.add(() => { 
                this.feelLevel = 0; 
                this.soundPlayer.fadeTrack({ name:SoundConfig.MAIN_MUSIC, from:undefined, to: 0, duration:2e4 })}, 10)
            this.tlCounter.add(() => {
                this.soundPlayer.stopTrack(SoundConfig.MAIN_MUSIC);
                this.RemoveLoop(SoundConfig.MAIN_MUSIC);
            }, 30)
        }
    }

    public static StartMainMusic(first?: boolean): void {
        this.soundPlayer.playTrack({ name: SoundConfig.MAIN_AMBIANCE });
        this.ApplyLoop(SoundConfig.MAIN_AMBIANCE);
    }

    private static ApplyLoop(loop:string):void{
        if(!this.currentLoop.includes(loop)) this.currentLoop.push(loop);
    }
   
    public static ChangeToLoop(newLoop:string[]): void {
        this.emptyLoop();
        newLoop.forEach(l => this.ApplyLoop(l))
    }
    
    public static emptyLoop(): void {
        this.stopAmbient();
        while(this.currentLoop.length) this.RemoveLoop(this.currentLoop[0]);
    }

    private static RemoveLoop(loop:string):void{
        ArrayHelper.removeFirstMatchElement(this.currentLoop,loop);
    }

    public static OnEndFS(isSuper: boolean, wasGood: boolean): void {
    }

    public static StopAllSounds(): void {
        if (this.soundPlayer.allPlayers()[0]) // Loaded
            this.soundPlayer.allPlayers().forEach(p => { p.stop() });
    }

    public static onEndClick(): void {
        this.playSoundEffect(SoundConfig.CONTINUE_AFTER_FS);
        this.StartMainMusic(false);
    }

    public static stopSoundEffect(name: string): void {
        this.soundPlayer.stopTrack(name);
    }

    public static fadeSound(name: string, from: number = 1, to: number, duration: number): void {
        this.soundPlayer.fadeTrack({
            name: name,
            duration: duration,
            from: from,
            to: to
        });
    }
}